import { useEffect, useRef } from 'react';
import { pendo } from '@frontend/tracking';

export const useBannerCarouselTracking = ({
  activeSlides = [],
  currentSlideIndex,
  trackingId = 'banner-carousel-impression',
}: {
  activeSlides: string[];
  currentSlideIndex: number;
  trackingId?: string;
}) => {
  const trackedBannersRef = useRef<Set<string>>(new Set());

  // Track banner impressions (whenever active slide changes and is valid)
  useEffect(() => {
    if (activeSlides.length > 0 && currentSlideIndex >= 0 && currentSlideIndex < activeSlides.length) {
      const activeBannerName = activeSlides[currentSlideIndex];
      if (!trackedBannersRef.current.has(activeBannerName)) {
        trackedBannersRef.current.add(activeBannerName);
        pendo.track(trackingId, {
          bannerName: activeBannerName,
        });
      }
    }
  }, [activeSlides, currentSlideIndex, trackingId]);
};
